import { environmentHttpClient } from "client/Api/httpClient";

export function dismissTermsNotice(signal?: AbortSignal): Promise<void> {
	return environmentHttpClient.put<void>(
		"/UiApi/Terms/Notice/Dismiss",
		undefined,
		{ signal }
	);
}
